<script setup>
import { computed, ref } from "vue";
import NotificationBar from "@/Components/NotificationBar.vue";
import { mdiCheckCircle, mdiContrastCircle, mdiAlertCircle } from "@mdi/js";
import { usePage } from '@inertiajs/inertia-vue3';

const notificationSettingsModel = ref([]);
const notificationsOutline = computed(
  () => notificationSettingsModel.value.indexOf("outline") > -1
);

//const success = computed(() => usePage().props.value.flash.success);
const message = computed(() => usePage().props.value.flash.message);
const type = computed(() => usePage().props.value.flash.type);
//const errors = computed(() => usePage().props.value.flash.errors);
//const hasErrors = computed(() => Object.keys(errors.value).length > 0);

const isAlertActive = ref(false)
if (message.value) {
    isAlertActive.value = true
}

let time = 1
if (type.value == 'success') {
    time = 10
} else if (type.value == 'warning') {
    time = 30
} else if (type.value == 'danger') {
    time = 60
}

setTimeout(() => {
    isAlertActive.value = false
}, time * 1000)

</script>
<template>
    <!-- <div v-if="hasErrors">
        <div class="font-medium text-red-600">Ups! Algo está mal.</div>

        <ul class="mt-3 list-disc list-inside text-sm text-red-600">
            <li v-for="(error, key) in errors" :key="key">{{ error }}</li>
        </ul>
    </div> -->
    <div v-if="isAlertActive" class="container mx-auto px-8 sticky top-1 z-50">
        <div class="grid-cols-1 w-full flex justify-end">
            <NotificationBar :color="type" :icon="(type=='success' ? mdiCheckCircle : (type == 'warning' ? mdiContrastCircle : mdiAlertCircle))"
                :outline="notificationsOutline"  class="col-span-1 p-2 lg:p-4 absolute">
                <!-- <b v-if="color=='success'">Ok - </b>
                <b v-else-if="color=='warning'">! </b>
                <b v-else-if="color=='danger'">Error - </b> -->
                <div class="mr-3" v-text="message"></div>
            </NotificationBar>
        </div>
    </div>
</template>

